import { createApp } from 'vue'
// import { createApp } from 'vue'
import App from './App.vue'
// import Rollbar from 'rollbar'
import router from '@/routes'
import '@/main.css'
import i18n from '@/lang/i18n'
import '@/config/validate'
import { createHead } from '@vueuse/head'
import Notifications from '@kyvg/vue3-notification'
// Amplify v6: Configuration is handled dynamically in Connection.ts with Auth0 token
const app = createApp(App)
const head = createHead()

// const env = process.env.VUE_APP_ENVIRONMENT || 'local'
const rollbar = undefined
// const rollbar =
//   env != 'local'
//     ? new Rollbar({
//         accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN || '',
//         captureUncaught: false,
//         captureUnhandledRejections: false,
//         environment: env,
//       })
//     : undefined

app.config.globalProperties.$rollbar = rollbar
app.provide('$rollbar', rollbar)

app.config.errorHandler = () =>
  // err: unknown,
  // instance: ComponentPublicInstance | null,
  // info: string
  {
    // console.log(err)
    // if (env != 'local') {
    //   rollbar?.error(err as string)
    // }
  }

app.use(router).use(i18n).use(head).use(Notifications).mount('#app')

// app.config.globalProperties.$rollbar = rollbar
